module.exports = __webpack_public_path__ + "static/media/Banner-QuatOne10.8861be5c.jpg";